import { Button, Header } from "@datagame/ui";
import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

import { QuickRankActionName, QuickRankRenderableDestinations } from "../../../reducers/quickrank";
import { RatingScale } from "../../shared/RatingScale";
import { useQuickRankState } from "../../../hooks/quickrank/useQuickRankState";

import styles from "./RatingModal.module.scss";

const { RATED } = QuickRankRenderableDestinations;

export const RatingModal = () => {
  const { t } = useTranslation("common");
  const [
    {
      configuration: {
        ratingLeftLabel,
        ratingRightLabel,
        ratingScaleSize,
        gameVisuals: { themeColor },
      },
      cards: { [RATED]: rated },
    },
    dispatch,
  ] = useQuickRankState();
  const shouldShowRatingScale = rated.length > 0;
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  const height = isDesktop ? 320 : 208;
  const initialRating = Math.ceil(ratingScaleSize / 2);
  const [ratingScore, setRatingScore] = useState(initialRating);

  const handleCardRating = () => {
    dispatch({
      type: QuickRankActionName.RATE_CARD,
      payload: {
        ratingScore,
      },
    });

    setRatingScore(initialRating);
  };

  return (
    <motion.div
      initial={{
        y: height,
      }}
      animate={{
        y: shouldShowRatingScale ? 0 : height,
        transition: {
          duration: 0.5,
        },
      }}
      className={styles.ratingModal}
    >
      <div className={styles.content}>
        <div className={styles.labels}>
          <Header className={styles.labelDislike} variant="h6">
            {ratingLeftLabel}
          </Header>
          <Header className={styles.labelLike} variant="h6">
            {ratingRightLabel}
          </Header>
        </div>
        <RatingScale onChange={setRatingScore} value={ratingScore} min={1} max={ratingScaleSize} />
        <Button
          customColor={themeColor}
          onClick={handleCardRating}
          className={styles.submitButton}
          size="large"
          kind="outline"
        >
          {t("continue")}
        </Button>
      </div>
    </motion.div>
  );
};
